import React from 'react';
import Breadcrumb from '../components/common/Breadcrumb';

const ShippingPolicyPage = () => {
  return (
    <div className="bg-white min-h-screen py-8">
      <div className="container mx-auto px-4 md:px-8 max-w-4xl">
        <div className="border-b pb-4 mb-8">
          <Breadcrumb items={[{ label: 'Home', path: '/' }, { label: 'Shipping Policy', path: '/shipping-policy' }]} />
        </div>
        <h1 className="text-3xl font-light text-center text-gray-900 mb-8 tracking-wide">Shipping Policy</h1>
        <div className="space-y-4 text-gray-700 text-sm leading-relaxed">
          <p>We aim to deliver your order as quickly as possible.</p>
          <p><strong>Processing Time:</strong> Orders are processed within 1-2 business days after payment confirmation.</p>
          <p><strong>Shipping Time:</strong> Delivery typically takes 3-7 business days across Pakistan. Remote areas may take longer.</p>
          <p><strong>Shipping Charges:</strong> Free shipping on orders above Rs. 3,500. Standard shipping is Rs. 250 per order.</p>
          <p><strong>Tracking:</strong> Once shipped, you will receive a tracking number via email and SMS.</p>
        </div>
      </div>
    </div>
  );
};

export default ShippingPolicyPage;